import { getTranslation as u, addTranslation as d } from "../localStorage/index.mjs";
const f = (r, e) => {
  const { pageIndex: o = 1, pageSize: s = 10 } = e;
  return r + (o - 1) * s + 1;
};
function w(r, e) {
  const o = window.URL.createObjectURL(r), s = document.createElement("a");
  s.download = e, s.href = o, s.click(), window.URL.revokeObjectURL(o);
}
const g = async (r, e, o, s) => {
  const i = u(e);
  if (i) {
    const t = await fetch(e, { headers: { "If-None-Match": i } });
    if (t.status === 200) {
      const a = t.headers.get("Etag") || "", n = await t.text();
      d(e, a), s(null, { status: t.status, data: n });
    } else if (t.status === 304) {
      const a = await fetch(e);
      if (a.ok) {
        const n = await a.text();
        s(null, { status: a.status, data: n });
      } else
        s(a.statusText || "Error", { status: a.status, data: "" });
    } else
      s(t.statusText || "Error", { status: t.status, data: "" });
  } else {
    const t = await fetch(e);
    if (t.ok) {
      const a = t.headers.get("Etag") || "", n = await t.text();
      d(e, a), s(null, { status: t.status, data: n });
    } else
      s(t.statusText || "Error", { status: t.status, data: "" });
  }
};
export {
  f as addTableOrder,
  w as blobDownloadFile,
  g as i18nRequest
};
